/* eslint-disable no-fallthrough */
/* eslint-disable default-case */
import React, { useState, useEffect } from 'react';
import {
   Table, Space, Tooltip, Button, Input, Row, Col,
   Modal, Typography, Image, Segmented, Select, message
} from 'antd';
import * as AntDIcons from '@ant-design/icons';
import Highlighter from 'react-highlight-words';
import axios from 'axios';
import Utils from '../../../misc/Utils';
import {
   EMSSummaryReport,
   MTSummaryReport,
   SHSSummaryReport,
   DiagnosticCompetencyListReport
} from '../diagnostic-reports';
import { getReportFamily } from '../diagnostic-reports/reportConfigResolver';

import html2pdf from 'html2pdf.js';
import PropTypes from 'prop-types';

const { Text } = Typography;
const { Option } = Select;

// /**
//  * Displays student summary reports for diagnostics.
//  * @component
//  * @param {Object} props
//  * @param {string|number} props.level - The grade/level identifier.
//  * @param {string} props.type - The diagnostic type (e.g., 'pre', 'post').
//  * @param {string} [props.template] - The template/grade name.
//  * * @param {string|number} [props.school_year] - The school year.
//  */

// BStudentSummaryReports2.propTypes = {
//    level: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
//    type: PropTypes.string.isRequired,
//    template: PropTypes.string,
//    school_year: PropTypes.string.isRequired,
// };

export function BStudentSummaryReports2(props) {
   const [searchText, setSearchText] = React.useState("");
   const [searchedColumn, setSearchedColumn] = React.useState("");

   // const [diagnosticList, setDiagnosticList] = useState([]);
   const [showSummaryReport, setShowSummaryReport] = useState(false);
   // const [listLoading, setListLoading] = useState(false);
   const [downloadStatus, setDownloadStatus] = useState(false);
   const [sectionList, setSectionList] = useState(null);
   // const [sectionOption, setSectionOption] = useState(0);
   const [selectedSections, setSelectedSections] = useState("-1");
   const [selectedSectionsDesc, setSelectedSectionsDesc] = useState("-1");
   // const [selectedSections, setSelectedSections] = useState(props.sections);
   // const [selectedSectionsDesc, setSelectedSectionsDesc] = useState(props.sections_desc);
   const [assessmentID, setAssessmentID] = useState(null);
   const [subject, setSubject] = useState(null);
   const [subjectDesc, setSubjectDesc] = useState(null);
   const [template, setTemplate] = useState(null);
   const [activeReportType, setActiveReportType] = useState('summary');

   // const level = props.level;
   // const type = props.type;

   useEffect(() => {
      Utils.verifyJwt();

      getSections();
   }, []);

   const handleSearch = (selectedKeys, confirm, dataIndex) => {
      confirm();
      setSearchText(selectedKeys[0]);
      setSearchedColumn(dataIndex);
   };

   const handleReset = clearFilters => {
      clearFilters();
      setSearchText("");
   };

   const getColumnSearchProps = dataIndex => ({
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
         <div style={{ padding: 8 }}>
            <Input
               ref={node => {
               }}
               placeholder={`Search ${dataIndex}`}
               value={selectedKeys[0]}
               onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
               onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
               style={{ width: 188, marginBottom: 8, display: 'block' }}
            />
            <Space>
               <Button
                  type="primary"
                  onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                  icon={<AntDIcons.SearchOutlined />}
                  size="small"
                  style={{ width: 90 }}>
                  Search
               </Button>
               <Button
                  size="small"
                  style={{ width: 90 }}
                  onClick={() => {
                     handleReset(clearFilters);
                     confirm({ closeDropdown: false });
                     setSearchText(selectedKeys[0]);
                     setSearchedColumn(dataIndex);
                  }}
               >
                  Reset
               </Button>
            </Space>
         </div>
      ),
      filterIcon: filtered => <AntDIcons.SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
      onFilter: (value, record) =>
         record[dataIndex]
            ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
            : '',
      render: text =>
         searchedColumn === dataIndex ? (
            <Highlighter
               highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
               searchWords={[searchText]}
               autoEscape
               textToHighlight={text ? text.toString() : ''}
            />
         ) : (
            text
         ),
   });

   const columns = [
      {
         title: 'Diagnostic Title',
         key: 'title',
         ...getColumnSearchProps('title'),
         ellipsis: {
            showTitle: false,
         },
         render: payload => (
            <Tooltip placement="topLeft" title={payload.title}>
               <Text>
                  {
                     payload.title
                  }
               </Text>
            </Tooltip>
         ),
         width: '65%'
      },
      {
         title: 'Subject',
         key: 'subject_desc',
         ...getColumnSearchProps('subject_desc'),
         ellipsis: {
            showTitle: false,
         },
         render: payload => (
            <Tooltip placement="topLeft" title={payload.subject_desc}>
               <Text>
                  {
                     payload.subject_desc
                  }
               </Text>
            </Tooltip>
         ),
         width: '20%'
      },
      {
         title: <div style={{ textAlign: 'center' }}>Report</div>,
         render: payload => (
            <>
               <div style={{ textAlign: 'center' }}>
                  <Tooltip placement='top' title={"Show Summary Report"}>
                     <AntDIcons.SolutionOutlined style={{ cursor: 'pointer' }} onClick={() => handleShowReport(payload.id, payload.subject, payload.subject_desc, payload.standard_level_name)} />
                  </Tooltip>
               </div>
            </>

         ),
         width: '15%',
      },
   ].filter(item => !item.hidden);

   const parseSectionList = (value) => {
      if (value === null || value === undefined) return [];

      return value.toString().split(",").map(item => item.trim()).filter(Boolean);
   }

   const buildSectionOptions = (sectionIds, nameById) => {
      return sectionIds.map(id => ({
         value: id,
         name: (nameById && nameById.get(id)) || id
      }));
   }

   const getSections = () => {
      const sectionIds = parseSectionList(props.sections);

      if (sectionIds.length === 0) {
         setSectionList([]);
         return;
      }

      // //-- Prefer the section names that came from the assignment
      // const sectionNames = parseSectionList(props.sections_desc);

      // if (sectionNames.length > 0) {
      //    const nameById = new Map();
      //    sectionIds.forEach((id, index) => {
      //       nameById.set(id, sectionNames[index]);
      //    });

      //    setSectionList(buildSectionOptions(sectionIds, nameById));
      //    return;
      // }

      //-- Fallback: resolve section names from the section master list
      axios.get(`${process.env.REACT_APP_API_MANAGEMENT}/getsectionlist`).then((response) => {
         const lookup = response.data || [];
         const nameById = new Map();

         lookup.forEach(item => {
            if (item.id !== undefined && item.id !== null) {
               nameById.set(item.id.toString(), item.section_desc);
            }
         });

         setSectionList(buildSectionOptions(sectionIds, nameById));
      }, () => {
         setSectionList(buildSectionOptions(sectionIds, null));
      });
   }

   // const getDiagnosticTitles = () => {
   //    setListLoading(true);

   //    var url = `${process.env.REACT_APP_API_BRAINEE_DIAGNOSTIC}/v3/getlist?t=${type}&l=${level}`;

   //    axios.get(url).then((response) => {
   //       if (response.data) {
   //          const data = response.data;

   //          getSections(level);
   //          setDiagnosticList(data);
   //          setListLoading(false);
   //       }
   //    }, (error) => {
   //       setListLoading(false);
   //    });
   // }

   const displaySummaryReport = () => {
      if (!showSummaryReport) return null;

      const commonProps = {
         assessment_id: assessmentID,
         template,
         section_id: selectedSections,
         section_desc: selectedSectionsDesc,
         diagnostic_type: props.type,
         subject: props.subject_desc,
         subject_id: props.subject_id,
         school_year: props.school_year,
         assignment_id: props.assignment_id,
         pre_assignment_id: props.pre_assignment_id,
      };

      const reportFamily = getReportFamily(template, props.subject_id);
      let ReportComponent = SHSSummaryReport;

      if (reportFamily === 'ems') {
         ReportComponent = EMSSummaryReport;
      } else if (reportFamily === 'mt') {
         ReportComponent = MTSummaryReport;
      }

      return ReportComponent ? (
         <ReportComponent {...commonProps} />
      ) : (
         Modal.info({ content: 'Report not yet available.', centered: true })
      );
   };

   const displayCompetencyListReport = () => {
      if (!showSummaryReport) return null;

      return (
         <DiagnosticCompetencyListReport
            assignment_id={props.assignment_id}
            assessment_id={assessmentID}
            pre_assignment_id={props.pre_assignment_id}
            section_id={selectedSections}
            school_year={props.school_year}
            version={props.version}
            diagnostic_type={props.type}
            template={template}
            subject_id={props.subject_id}
            subject={props.subject_desc}
            diagnostic_title={props.diagnostic_title}
         />
      );
   };

   const handleDownloadReport = (report_type = 'summary') => {
      var element = null;
      var reportFileName = "";

      if (report_type === 'summary') {
         element = document.getElementById('summary-report');
         reportFileName = 'Summary Results ' + (props.type === 'pre' ? 'Pre' : 'Post') + ' Test for ' + template + '.pdf';
      }

      if (report_type === 'competency') {
         element = document.getElementById('competency-list-report');
         reportFileName = 'Student Competency List ' + (props.type === 'pre' ? 'Pre' : 'Post') + ' Test for ' + template + '.pdf';
      }

      if (element !== null) {
         const exportRoot = element.cloneNode(true);
         const exportContainer = document.createElement('div');
         exportContainer.style.position = 'fixed';
         exportContainer.style.left = '-100000px';
         exportContainer.style.top = '0';
         exportContainer.style.width = '1024px';
         exportContainer.style.background = '#ffffff';
         exportContainer.style.padding = '0';
         exportContainer.appendChild(exportRoot);
         document.body.appendChild(exportContainer);

         exportRoot.style.width = '100%';
         exportRoot.style.maxWidth = '100%';
         exportRoot.style.overflow = 'visible';
         // exportRoot.style.fontSize = '12px';

         const sourceCanvases = element.querySelectorAll('canvas');
         const clonedCanvases = exportRoot.querySelectorAll('canvas');
         sourceCanvases.forEach((sourceCanvas, idx) => {
            const targetCanvas = clonedCanvases[idx];
            if (!targetCanvas) return;

            targetCanvas.width = sourceCanvas.width;
            targetCanvas.height = sourceCanvas.height;
            targetCanvas.style.width = sourceCanvas.style.width || `${sourceCanvas.width}px`;
            targetCanvas.style.height = sourceCanvas.style.height || `${sourceCanvas.height}px`;

            const targetContext = targetCanvas.getContext('2d');
            if (targetContext) {
               targetContext.clearRect(0, 0, targetCanvas.width, targetCanvas.height);
               targetContext.drawImage(sourceCanvas, 0, 0);
            }
         });

         exportRoot.querySelectorAll('.ant-table-content, .ant-table-body, .ant-table-container').forEach((node) => {
            node.style.overflow = 'visible';
            node.style.maxHeight = 'none';
            node.style.height = 'auto';
         });         

         exportRoot.querySelectorAll('.dashboard-item-inner3, .essay_list_container, .section_to_print').forEach((node) => {
            node.style.overflow = 'visible';
            node.style.maxHeight = 'none';
            node.style.height = 'auto';
         });

         if (report_type === 'competency') {
            exportRoot.style.fontSize = '11px';

            exportRoot.querySelectorAll('table').forEach((node) => {
               node.style.width = '100%';
               node.style.tableLayout = 'fixed';
            });

            exportRoot.querySelectorAll('.ant-table-wrapper, .ant-table, .ant-table-content, .ant-table-body').forEach((node) => {
               node.style.width = '100%';
               node.style.maxWidth = '100%';
               node.style.overflow = 'visible';
               node.style.height = 'auto';
               node.style.maxHeight = 'none';
            });

            exportRoot.querySelectorAll('.ant-table-body table').forEach((node) => {
               node.style.width = '100%';
               node.style.tableLayout = 'fixed';
            });

            exportRoot.querySelectorAll('.competency-filter-panel').forEach((node) => node.remove());

            const diagnosticTitle = exportRoot.getAttribute('data-diagnostic-title') || '-';
            const totalItems = exportRoot.getAttribute('data-total-items') || '-';

            const pdfHeader = document.createElement('div');
            pdfHeader.style.margin = '0 0 14px 0';
            pdfHeader.style.fontFamily = 'Calibri, Arial, sans-serif';
            pdfHeader.style.fontSize = '12pt';
            pdfHeader.style.lineHeight = '1.4';
            pdfHeader.innerHTML = `
               <div><strong>Student List by Overall Competency</strong></div>
               <div>Diagnostic Title: <strong>${diagnosticTitle}</strong></div>
               <div>Total Number of Items: <strong>${totalItems}</strong></div>
            `;
            exportRoot.prepend(pdfHeader);
         }

         const styleEl = document.createElement('style');
         styleEl.innerHTML = `
            .ant-table table { width: 100% !important; table-layout: auto !important; }
            .ant-table-header, .ant-table-body { overflow: visible !important; max-height: none !important; height: auto !important; }
            .ant-table-thead { display: table-header-group !important; }
            .ant-table-thead > tr > th, .ant-table-tbody > tr > td { white-space: normal !important; word-break: break-word !important; }
            .ant-table-thead > tr, .ant-table-tbody > tr { page-break-inside: avoid !important; }
            .competency-list-table .ant-table-thead > tr > th, .competency-list-table .ant-table-tbody > tr > td { font-size: 10px !important; padding: 4px 6px !important; }
            .competency-list-table .ant-table table { table-layout: fixed !important; }
         `;
         exportRoot.prepend(styleEl);

         var opt = {
            margin: 0.5,
            filename: reportFileName,
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: { scale: 2, useCORS: true, scrollY: 0, windowWidth: exportContainer.scrollWidth },
            pagebreak: report_type === 'competency'
               ? { mode: ['css', 'legacy'] }
               : { mode: ['css', 'legacy', 'avoid-all'] },
            jsPDF: {
               unit: 'in',
               format: 'letter',
               orientation: report_type === 'competency' ? 'landscape' : 'portrait'
            }
         };

         html2pdf().from(exportRoot).set(opt).save().then(() => {
            document.body.removeChild(exportContainer);
         }).catch(() => {
            document.body.removeChild(exportContainer);
         });
      }      
   }

   // const handleChange = (val) => {
   //    setSectionOption(val);
   // }

   const handleSectionSelect = (val) => {
      var selected_sections = val.length > 0 ? val.join(",") : "";
      setSelectedSections(selected_sections);

      var section_desc = "";

      val.forEach((element) => {
         let item = sectionList.find(o => o.value === element);

         if (section_desc !== "")
            section_desc += ", ";

         section_desc += item ? item.name : element;
      });

      setSelectedSectionsDesc(section_desc);
   }

   // const handleShowReport = (assessment_id, subject, subject_desc, level_desc) => {
   //    if (selectedSections !== "" && selectedSections !== "-1") {
   //       setAssessmentID(assessment_id);
   //       setSubject(subject);
   //       setSubjectDesc(subject_desc);
   //       setTemplate(level_desc);
   //       setShowSummaryReport(true);
   //    } else {
   //       message.info('Please select sections to include in the report.')
   //    }
   // }

   const handleShowReport = () => {
      if (selectedSections !== "" && selectedSections !== "-1") {
         setAssessmentID(props.assessment_id);
         setSubject(props.subject_id);
         setSubjectDesc(props.subject_desc);
         setTemplate(props.level);
         setActiveReportType('summary');
         setShowSummaryReport(true);
      } else {
         message.info('Please select sections to include in the report.')
      }
   }

   return (
      <>
         <div className="dashboard-item-inner3">
            <Row gutter={[10, 10]} style={{ paddingBottom: "20px" }} >
               <Col span={24}>
                  <p>Sections to be included the report</p>
                  {
                     <Select
                        showArrow
                        size='middle'
                        style={{ width: '100%' }}
                        allowClear
                        placeholder="Select Sections"
                        onChange={(val) => handleSectionSelect(val)}
                        mode="multiple"
                     >
                        {
                           sectionList !== null &&
                           sectionList.map(({ value, name }) => {
                              return <Option key={value} value={value}>{name}</Option>
                           })
                        }
                     </Select>
                  }

               </Col>
            </Row>
            <Row gutter={[10, 10]} style={{ paddingBottom: "20px" }} >
               <Col span={24} style={{ display: "flex", justifyContent: "center" }}>
                  <Button
                     shape='round' type="primary"
                     onClick={() => handleShowReport()}
                  >
                     Show Summary Report
                  </Button>
               </Col>
            </Row>

         </div >

         <Modal
            key='show-diagnostic-summary-report'
            title={<div><Image src='../images/brainee_mascot.png' preview={false} height="30px" style={{ minWidth: '30px', maxHeight: '100px' }} /> {activeReportType === 'summary' ? ("Summary Results  " + (props.type === 'pre' ? 'Pre' : 'Post') + " Test for " + template) : ("Student List by Overall Competency - " + (props.type === 'pre' ? 'Pre' : 'Post') + " Test for " + template)}</div>}
            okText={"Close"}
            cancelButtonProps={{ style: { display: 'none' } }}
            okButtonProps={{ shape: "round", style: { display: 'none' } }}
            centered
            destroyOnClose={true}
            open={showSummaryReport}
            width='75%'
            style={{ maxWidth: '1000px' }}
            footer={[
               <Space>
                  <Button
                     shape='round'
                     type='primary'
                     onClick={() => setActiveReportType(activeReportType === 'summary' ? 'competency' : 'summary')}
                  >
                     {activeReportType === 'summary' ? 'Generate Competency List' : 'Show Summary Report'}
                  </Button>
                  <Button
                     shape='round' type="primary"
                     loading={downloadStatus}
                     onClick={() => handleDownloadReport(activeReportType)}
                  >
                     Download
                  </Button>
                  <Button shape='round' type='primary' onClick={() => { setShowSummaryReport(false); }}>
                     Close
                  </Button>
               </Space>
            ]}
         >
            <div className='essay_list_container' style={{ background: "#fff" }}>
               <div className='section_to_print'>
                  {activeReportType === 'summary' ? displaySummaryReport() : displayCompetencyListReport()}
               </div>
            </div>
         </Modal>
      </>
   );
}
